export const CHECK_VERSION = 'CHECK_VERSION';
